export function sqftToM2(sqft: number): number {
  return Math.round(sqft / 10.764);
}

export function m2ToSqft(m2: number): number {
  return Math.round(m2 * 10.764);
}
